// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeLogTableQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ChangeRequestsFilter>;
  orderBy?: Types.InputMaybe<Types.ChangeRequestOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ChangeLogTableQuery = { __typename?: 'Query', changeRequests: { __typename?: 'ChangeRequestsPageResult', entities: Array<{ __typename?: 'ChangeRequest', id: string, name: string, rationale: string, estimateBudgetImpactInCents?: number | null | undefined, markupBasisPoints?: number | null | undefined, estimatedBuyerOutOfPocketInCents?: number | null | undefined, estimatedRetailPriceInCents?: number | null | undefined, estimateMarginImpactBasisPoints?: number | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], changeTypes: Array<Types.ChangeType>, status: { __typename?: 'ChangeRequestStatusDetail', code: Types.ChangeRequestStatus, name: string }, source: { __typename?: 'ChangeRequestSourceDetail', code: Types.ChangeRequestSource, name: string }, scopes: Array<{ __typename?: 'ChangeRequestScope', id: string, target:
          | { __typename: 'StandaloneProject', id: string, name: string }
          | { __typename: 'Region', id: string, name: string }
          | { __typename: 'Development', id: string, name: string }
          | { __typename: 'Market', id: string, name: string }
          | { __typename: 'Community', id: string, name: string }
          | { __typename: 'Subdivision', id: string, name: string }
          | { __typename: 'Lot', id: string, name: string }
          | { __typename: 'Structure', id: string, name: string }
          | { __typename: 'Unit', id: string, name: string }
         }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type ChangeLogTableFragment = { __typename?: 'ChangeRequestsPageResult', entities: Array<{ __typename?: 'ChangeRequest', id: string, name: string, rationale: string, estimateBudgetImpactInCents?: number | null | undefined, markupBasisPoints?: number | null | undefined, estimatedBuyerOutOfPocketInCents?: number | null | undefined, estimatedRetailPriceInCents?: number | null | undefined, estimateMarginImpactBasisPoints?: number | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], changeTypes: Array<Types.ChangeType>, status: { __typename?: 'ChangeRequestStatusDetail', code: Types.ChangeRequestStatus, name: string }, source: { __typename?: 'ChangeRequestSourceDetail', code: Types.ChangeRequestSource, name: string }, scopes: Array<{ __typename?: 'ChangeRequestScope', id: string, target:
        | { __typename: 'StandaloneProject', id: string, name: string }
        | { __typename: 'Region', id: string, name: string }
        | { __typename: 'Development', id: string, name: string }
        | { __typename: 'Market', id: string, name: string }
        | { __typename: 'Community', id: string, name: string }
        | { __typename: 'Subdivision', id: string, name: string }
        | { __typename: 'Lot', id: string, name: string }
        | { __typename: 'Structure', id: string, name: string }
        | { __typename: 'Unit', id: string, name: string }
       }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } };

export type ChangeRequestFragment = { __typename?: 'ChangeRequest', id: string, name: string, rationale: string, estimateBudgetImpactInCents?: number | null | undefined, markupBasisPoints?: number | null | undefined, estimatedBuyerOutOfPocketInCents?: number | null | undefined, estimatedRetailPriceInCents?: number | null | undefined, estimateMarginImpactBasisPoints?: number | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], changeTypes: Array<Types.ChangeType>, status: { __typename?: 'ChangeRequestStatusDetail', code: Types.ChangeRequestStatus, name: string }, source: { __typename?: 'ChangeRequestSourceDetail', code: Types.ChangeRequestSource, name: string }, scopes: Array<{ __typename?: 'ChangeRequestScope', id: string, target:
      | { __typename: 'StandaloneProject', id: string, name: string }
      | { __typename: 'Region', id: string, name: string }
      | { __typename: 'Development', id: string, name: string }
      | { __typename: 'Market', id: string, name: string }
      | { __typename: 'Community', id: string, name: string }
      | { __typename: 'Subdivision', id: string, name: string }
      | { __typename: 'Lot', id: string, name: string }
      | { __typename: 'Structure', id: string, name: string }
      | { __typename: 'Unit', id: string, name: string }
     }>, groups: Array<{ __typename?: 'ChangeRequestGroup', id: string, name: string }> };

export type ChangeRequestScopeNameFragment = { __typename?: 'ChangeRequestScope', id: string, target:
    | { __typename: 'StandaloneProject', id: string, name: string }
    | { __typename: 'Region', id: string, name: string }
    | { __typename: 'Development', id: string, name: string }
    | { __typename: 'Market', id: string, name: string }
    | { __typename: 'Community', id: string, name: string }
    | { __typename: 'Subdivision', id: string, name: string }
    | { __typename: 'Lot', id: string, name: string }
    | { __typename: 'Structure', id: string, name: string }
    | { __typename: 'Unit', id: string, name: string }
   };

export const ChangeRequestScopeNameFragmentDoc = gql`
    fragment ChangeRequestScopeName on ChangeRequestScope {
  id
  target {
    __typename
    ... on Development {
      id
      name
    }
    ... on Project {
      id
      name
    }
  }
}
    `;
export const ChangeRequestFragmentDoc = gql`
    fragment ChangeRequest on ChangeRequest {
  id
  name
  status {
    code
    name
  }
  rationale
  source {
    code
    name
  }
  estimateBudgetImpactInCents
  markupBasisPoints
  estimatedBuyerOutOfPocketInCents
  estimatedRetailPriceInCents
  estimateMarginImpactBasisPoints
  updatedAt
  scopes {
    ...ChangeRequestScopeName
  }
  changeTypes
  groups {
    id
    name
  }
}
    ${ChangeRequestScopeNameFragmentDoc}`;
export const ChangeLogTableFragmentDoc = gql`
    fragment ChangeLogTable on ChangeRequestsPageResult {
  entities {
    ...ChangeRequest
  }
  pageInfo {
    hasNextPage
    totalCount
  }
}
    ${ChangeRequestFragmentDoc}`;
export const ChangeLogTableDocument = gql`
    query ChangeLogTable($filter: ChangeRequestsFilter, $orderBy: ChangeRequestOrder, $page: PageFilter) {
  changeRequests(filter: $filter, orderBy: $orderBy, page: $page) {
    ...ChangeLogTable
  }
}
    ${ChangeLogTableFragmentDoc}`;

/**
 * __useChangeLogTableQuery__
 *
 * To run a query within a React component, call `useChangeLogTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useChangeLogTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeLogTableQuery, ChangeLogTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeLogTableQuery, ChangeLogTableQueryVariables>(ChangeLogTableDocument, options);
      }
export function useChangeLogTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeLogTableQuery, ChangeLogTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeLogTableQuery, ChangeLogTableQueryVariables>(ChangeLogTableDocument, options);
        }
// @ts-ignore
export function useChangeLogTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogTableQuery, ChangeLogTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeLogTableQuery, ChangeLogTableQueryVariables>;
export function useChangeLogTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogTableQuery, ChangeLogTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeLogTableQuery | undefined, ChangeLogTableQueryVariables>;
export function useChangeLogTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeLogTableQuery, ChangeLogTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeLogTableQuery, ChangeLogTableQueryVariables>(ChangeLogTableDocument, options);
        }
export type ChangeLogTableQueryHookResult = ReturnType<typeof useChangeLogTableQuery>;
export type ChangeLogTableLazyQueryHookResult = ReturnType<typeof useChangeLogTableLazyQuery>;
export type ChangeLogTableSuspenseQueryHookResult = ReturnType<typeof useChangeLogTableSuspenseQuery>;
export type ChangeLogTableQueryResult = Apollo.QueryResult<ChangeLogTableQuery, ChangeLogTableQueryVariables>;